import React from 'react';

import { Loader } from 'features/order-tracker/shared-components/LoadingIndicator/components/Loader';

import {
  LOADER_SUBTITLE,
  LOADER_TITLE,
} from '../../constants';

import styles from './styles.module.scss';

export const SlotsLoader: React.FC = () => (
  <div className={styles.loaderContainer}>
    <Loader />
    <h4>{LOADER_TITLE}</h4>
    <p>{LOADER_SUBTITLE}</p>
  </div>
);
